























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { DivIcon, LatLng, LatLngBounds, Point } from 'leaflet';
import { LControl, LControlZoom, LIcon, LImageOverlay, LMap, LMarker, LTileLayer } from 'vue2-leaflet';
import { mixins } from 'vue-class-component';
import LocationContract from '@/location/LocationContract';
import LocationTheme from '@/location/LocationTheme';
import Map from '@/mixins/Map';
import ScaledLocation from '@/location/ScaledLocation';
import TextualIcon from '@/components/TextualIcon.vue';

@Component({
    components: {
        LControl,
        LControlZoom,
        LIcon,
        LImageOverlay,
        LMap,
        LMarker,
        LTileLayer,
        TextualIcon,
    },
})
export default class OverviewMap extends mixins(Map) {
    @Prop({ type: Array, required: true })
    locations!: Array<LocationContract>;

    private scale = 1;

    private get scaledLocations(): Array<LocationContract> {
        return this.locations.map(location => new ScaledLocation(location, this.scale));
    }

    private get bounds(): LatLngBounds {
        const imageOverlaySize = 2048;

        return new LatLngBounds(
            new LatLng(0, imageOverlaySize * this.scale),
            new LatLng(imageOverlaySize * this.scale, 0),
        );
    }

    private get center(): LatLng {
        // @ts-ignore
        return new LatLngBounds(this.scaledLocations.map(location => location.latLng())).getCenter();
    }

    private get image(): string {
        return require('@/assets/images/overview.gif');
    }

    private icon(location: LocationContract): DivIcon {
        const instance = new Vue({
            render(h) {
                return h(TextualIcon, {
                    props: {
                        label: location.title,
                        inverted: location.theme === LocationTheme.LIGHT,
                    },
                });
            },
        });

        const icon = instance.$mount();

        const iconSize = 28;
        const width = (location.title.split('').length * 10) + iconSize;
        const height = 40;

        return new DivIcon({
            className: `leaflet-marker-icon--auto-width leaflet-marker-icon--${location.slug()}`,
            html: icon.$el.outerHTML,
            iconAnchor: new Point(width / 2, height / 2),
            iconSize: new Point(width, height),
        });
    }

    @Emit()
    private markerClicked(location: LocationContract): LocationContract {
        return location;
    }
}
